import { connectRouter } from 'connected-react-router'
import { combineReducers } from 'redux'
import { reducer as formReducer } from 'redux-form'

import browser from './browser'
import cart from './cart'
import checkHealth from './checkHealth'
import checkout from './checkout'
import comingSoon from './comingSoon'
import creditHistory from './creditHistory'
import credits from './credits'
import delivery from './delivery'
import favorite from './favorite'
import forgotPassword from './forgotPassword'
import { contactUsReducerPlugin } from './formPlugins'
import friends from './friends'
import home from './home'
import join from './join'
import location from './location'
import locationSearch from './locationSearch'
import notification from './notification'
import order from './order'
import orderDetail from './orderDetail'
import orderHistory from './orderHistory'
import pastorder from './pastorder'
import personalize from './personalize'
import preferences from './preferences'
import profile from './profile'
import slackbot from './slackbot'
import subscriptions from './subscriptions'
import ticket from './ticket'
import token from './token'
import unsubscribe from './unsubscribe'
import user from './user'

export default history =>
  combineReducers({
    browser,
    cart,
    checkHealth,
    checkout,
    comingSoon,
    creditHistory,
    credits,
    delivery,
    favorite,
    forgotPassword,
    form: formReducer.plugin({
      contactUs: contactUsReducerPlugin,
    }),
    friends,
    home,
    join,
    location,
    locationSearch,
    notification,
    order,
    orderDetail,
    orderHistory,
    pastorder,
    personalize,
    preferences,
    profile,
    router: connectRouter(history),
    slackbot,
    subscriptions,
    ticket,
    token,
    unsubscribe,
    user,
  })
